/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, w) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 */

	'use strict';
	/*globals Tc */

	/**
	 * AjaxCaptcha module implementation.
	 *
	 * @author Dimitri Sebeschuk
	 * @namespace Tc.Module
	 * @class AjaxCaptcha
	 * @extends Tc.Module
	 */
	Tc.Module.AjaxCaptcha = Tc.Module.extend({

		/**
		 * Triggered when the status message in the detail page should be reset
		 *
		 * @event resetstatus
		 */
		EVENT_CALLBACK_CAPTCHA: 'callbackCaptchaEvent',

		/**
		 * Initializes the Default module.
		 *
		 * @method init
		 * @constructor
		 * @param {jQuery|Zepto} $ctx the jquery context
		 * @param {Sandbox} sandbox the sandbox to get the resources from
		 * @param {String} modId the unique module id
		 */
		init: function ($ctx, sandbox, modId) {

			$ctx.insertBefore($ctx.closest('.buttongroup'));

			// call base constructor
			this._super($ctx, sandbox, modId);

		},


		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;

			mod.path = mod.getPath();
			mod.$ctx.on('captchaNeededEvent', $.proxy(mod.onCaptchaNeeded, mod));
			mod.$ctx.on('clearCaptchaEvent', $.proxy(mod.onClearCaptcha, mod));

			if(!mod.$ctx.data('disable-on-load')){
			mod.onCaptchaNeeded();
			}

			callback();
		},

		onCaptchaNeeded: function () {
			var mod = this;
			$.ajax({
				type: 'POST',
				url: "/etc/swisscom/servlets/public/forms/captcha.json",
				cache: false,
				data: {
					path: mod.path
				},
				success: function (data) {
					var clientValidation = mod.$ctx.find('.field').data('clientvalidation');
					if (data == 'true' || data === true || mod.$ctx.data('required') === true) {
						if (clientValidation) {
							clientValidation.required = true;
							mod.$ctx.find('.field').data('clientvalidation', clientValidation);
						}
						mod.createCaptcha();
					} else {
						if (clientValidation) {
							clientValidation.required = false;
							mod.$ctx.find('.field').data('clientvalidation', clientValidation);
						}
					}
				}
				//TODO Show exception
			});
		},

		getPath: function () {
			var mod = this,
				href,
				urlParser,
				form = mod.$ctx.closest('form'),
				path = form.find('input[name=":formstart"]').val(),
				formId = form.find('input[name=":formid"]').val();

			if (!path || !path.length) {
				//try to take path from canonical url
				urlParser = document.createElement('a');
				href = $('link[rel=canonical]').attr('href');
				if (href) {
					urlParser.href = href;
					path = urlParser.pathname;
				}
			}
			if (!path || !path.length) {
				//take path from location
				urlParser.href = w.location.href;
				//remove all selectors
				path = urlParser.pathname.replace(/(\.[^\/.]+)*\.html$/, '.html');
			}

			if (path && path.length > 0) {
				if(path.charAt(0) != '/'){
				path = '/' + path;
				}
				path = path.indexOf('/jcr:content') > 0 ? path.substring(0, path.indexOf('/jcr:content')) : path;
				//see ch.swisscom.forms.business.api.impl.FormDatabaseServiceImpl.logFormSubmit()
				path = formId && formId.length > 0 ? path+'?:formid='+formId : path;
			}

			return path;
		},

		callbackCaptchaHandler: function () {
			var mod = this;
			mod.$ctx.trigger(mod.EVENT_CALLBACK_CAPTCHA);
		},

		createCaptcha: function () {
			this.createCaptchaCount = this.createCaptchaCount || 0;
			if (typeof grecaptcha !== 'undefined') {
				var mod = this,
					publicKey = mod.$ctx.data('public-key'),
					theme = mod.$ctx.data('theme'),
					lang = mod.$ctx.data('lang'),
					id = 'captchaAjaxContainer_' + mod.$ctx.data('uid');

				if (mod.widgetId > -1) {
					debug.log('Tc.Module.AjaxCaptcha -> createCaptcha: captcha exists return!');
					grecaptcha.reset(mod.widgetId);
					mod.$ctx.show();
					return;
				}


				mod.widgetId = grecaptcha.render(id, {
					'sitekey': publicKey,
					'theme': theme,
					'callback': $.proxy(mod.callbackCaptchaHandler, mod)
				});
				mod.$ctx.show();
			} else {
				if (this.createCaptchaCount < 10) {
					this.createCaptchaCount++;
					setTimeout($.proxy(this.createCaptcha, this), 500);
				}
			}

		},

		onClearCaptcha: function () {
			var mod = this,
				id = 'captchaAjaxContainer_' + mod.$ctx.data('uid'),
				clientValidation = mod.$ctx.find('.field').data('clientvalidation');

			mod.widgetId = -1;
			$('#' + id, mod.$ctx).empty();
			mod.$ctx.hide();
			if (clientValidation) {
				clientValidation.required = false;
				mod.$ctx.find('.field').data('clientvalidation', clientValidation);
			}
		}

	});

}(Tc.$, window));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.AjaxCaptcha.js
// module id = 266
// module chunks = 0